var disableSubmitBtn = require('./_submitBtnDisable');
var enableSubmitBtn = require('./_submitBtnEnable');
var handleSubmitError = require('./_handleSubmitError');
var handleSubmitSuccess = require('./_handleSubmitSuccess');
module.exports = function formAsync(form, e) {
    	var
    	btn = $('#submit_' + form.attr('id')),
		danger = form.find('.ui-alert.ui-alert-danger');
    	if ( form.checkValidity && !form.checkValidity() ) {
        } else {
    		e.preventDefault();
        	$.ajax({
        		type: form.attr('method'),
    			url: form.attr('action'),
    			data: form.serialize(),
        		dataType: 'json',
        		'beforeSend': function() {
        			disableSubmitBtn(btn);
        			danger.addClass('hidden');
        		},
        		'success': function(response) {
        			enableSubmitBtn(btn);
        			if(response.success)  {
        				handleSubmitSuccess(form, response);
        			} else {
        				handleSubmitError(form, response);
        			}
        		},
        		'error': function(response) {
        			enableSubmitBtn(btn);
        			handleSubmitError(form, response);
        			if(danger !== undefined && danger !== null) {
        				danger.removeClass('hidden');
        			}
        		}
        	});
        }
};
